import store from "@/store"
import dangerousGoods from '@/config/dangerous-goods'
import { hereApi } from './here-api.js'
import { loadParams } from "./stop_distance_params.js"
import { truckWebFormatToApi } from '@/store/modules/truck'
import { defaultVehicleSettings } from '@/store/modules/truck'
import { hereParams, calculateShape } from './here-api-parms.js'
import { loadDetail } from '../../views/dispatchs/dispatch/api/new-index.js'
import { editLoad } from '../../../src/views/dispatchs/dispatch/api/new-index.js'
import { isRouteInfo, routeAdd, routeGet, shartRoute, routeAddApi, shareV3RrouteApi, setJsonAppImParmas } from '@/api/common-route.js'
import { parseServerRoutingResp } from '@/server-routing/services/route'
import Vue from "vue"
/**
 * @param { 保存路线 } addRoute 
 * @param { 分享到App端接口, 等待Assign } shareRoute 
 * @param { 处理距离问题 } editLoad 
 */

 const truckModel = {
    "limitedVehicleWeight": 2.268,
    "weightPerAxle": 0,
    "vehicleHeight": 0,
    "vehicleWidth": 0,
    "vehicleLength": 0,
    "truckAxleCount": 2,
    "trailersCount": 0,
    "hazardousGoods": ""
}

function getWaypointList(list) {
    return list.map(item => ({
        latitude: item.originalLocation.lat,
        longitude: item.originalLocation.lng
    }))
}

export function addRoute(id, data) {
    let result = {
        loadId: id,
        type: 'load',
        settings: JSON.stringify(['harshTurn', 'unpaved']),
        truckInfo: JSON.stringify(truckWebFormatToApi(defaultVehicleSettings)),
        wayPoints: JSON.stringify(data.hereResultData.waypoint),
        routes: JSON.stringify([{ routeJson: data.hereResultData.routeJson  }])
    }
    routeAdd(result).then((  ) => {
        console.warn('add-route-suceess');
    })
}
export function shareRoute(id, data, loadInfo) {
    return new Promise((resolve) => {
        shartRoute(id, hereParams(data.hereResultData, loadInfo)).then(( data ) => {
            resolve(data)
            console.warn('share-route-suceess');
        })
    })
    
}

export function EditLoadInfo(id, data) {
    editLoad(id, data).then(( ) => {
        console.warn('Edit-load-suceess');
    })
}

export function isHasRoute(id) {
    return new Promise((resolve, reject) => {
        isRouteInfo(id).then(( {res} ) => {
            let {savedRoute, sharedRoute, createdTrip} = res.data.data
            if(savedRoute && sharedRoute && createdTrip) {
                resolve(true)
            }
        }).catch(( error ) => {
            reject(error)
        })
    })
}

export function sendRoute(id, data, loadInfo) {
    let result = {
        loadId: id,
        settings: JSON.stringify(['harshTurn', 'unpaved']),
        truckInfo: JSON.stringify(truckWebFormatToApiSend(defaultVehicleSettings)),
        wayPoints: JSON.stringify(tripPlanPointInfo(loadInfo)),
        type: 'send',
        routes: JSON.stringify([{ routeJson: data.hereResultData.routeJson  }])
    }
    return new Promise((resolve) => {
      routeAddApi(result).then(( res ) => {
        resolve(res)
      }) 
    })
  }

export function getRoute(id, isHasDistance = false) {
    return new Promise(( success, err ) => {
        isRouteInfo(id).then(( {res} ) => {
            let {savedRoute, sharedRoute, createdTrip} = res.data.data
            if(savedRoute && sharedRoute && createdTrip && isHasDistance === false) {
                routeGet(id).then(({ res }) => {
                    let result = JSON.parse(res.data.data.routes) 
                    let route = parseServerRoutingResp(result[0].routeJson)
                    success({ route: calculateShape(route[0]), waypoint: getWaypointList(route[0].waypoint) })
                }).catch(( error ) => {
                    err(error)
                })
            }else if(savedRoute === false || createdTrip === false || sharedRoute === false || isHasDistance === true) {
                    let loadInfo = new Promise(( resolve, reject ) => {
                        let isHasLoad = store.state.dispatch.catchLoadInfo.some(itme => Number(itme.id) === Number(id));
                        if(isHasLoad) {
                            let index = store.state.dispatch.catchLoadInfo.findIndex(itme => Number(itme.id) === Number(id));
                            resolve(store.state.dispatch.catchLoadInfo[index])
                        }else {
                            loadDetail(id).then(( loadInfo ) => {
                                if(loadInfo.code == 200) {
                                    let result = loadInfo.data.loadInfo
                                    resolve(result) 
                                }else {
                                    Vue.$message.error(loadInfo.message)
                                }
                                
                            }).catch((error) => {
                                reject(error);
                            })
                        }
                    })
                    loadInfo.then(( resInfo ) => {
                        hereApi( resInfo ).then(( hereData ) => {
                            if(isHasDistance === true) {
                                EditLoadInfo(id, Object.assign({}, loadParams(resInfo, hereData), {distance: hereData.distance}))
                            }
                            if(!createdTrip) {
                                Promise.all([shareRoute(id, hereData ,resInfo), sendRoute(id, hereData, resInfo)]).then(( all ) => {
                                    const appNeedRouteParmas = {
                                      loadId: id,
                                      tripInfo: {...hereData.hereResultData.routeJson, truckModel: truckModel}
                                    }
                                  shareV3RrouteApi(appNeedRouteParmas, false).then(( x ) => {
                                    success({ route: calculateShape(hereData.hereResultData), waypoint: getWaypointList(hereData.hereResultData.waypoint) })
                                    const params = {
                                        loadId: id,
                                        webId: all[1].data.id,
                                        id: all[0].res.data.data,
                                        tripId: x.data.tripId[0],
                                        stops: resInfo?.dispatchStopPointList && resInfo?.dispatchStopPointList.length ? resInfo.dispatchStopPointList.length : 0,
                                        sendRoute: appFormatRouteFn(hereData.summary, resInfo)
                                    }
                                      setJsonAppImParmas(id, params,)
                                  })
                                })
                            }else {
                                Promise.all([shareRoute(id, hereData ,resInfo), sendRoute(id, hereData, resInfo)]).then(() => {
                                    success({ route: calculateShape(hereData.hereResultData), waypoint: getWaypointList(hereData.hereResultData.waypoint) })
                                })
                            }
                        }).catch(( error ) => {
                            err(error)
                        })
                    })
                }
        })
    })
}


const appFormatRouteFn = (duration, loadInfo) => {
    const estimatedJson = JSON.parse(loadInfo.estimatedJson)
    const drivingTimeHours = estimatedJson.time.h
    const drivingTimeMinutes = 0
    return {
        distance: duration,
        drivingTimeHours: drivingTimeHours,
        drivingTimeMinutes: drivingTimeMinutes,
        waypointList: [
          {
            title: loadInfo.pickupCity
          },
          {
            title: loadInfo.deliveryCity
          },
        ]
      }
}

const tripPlanParams = (data, type) => {
    return {
        value: type === 'origin' ? data.pickupCity : data.deliveryCity,
        timeZone: type === 'origin' ? data.pickupTimezone : data.deliveryTimezone,
        dwellTime: '', 
        departureTime: '', 
        stopPointType: type,
        stopType: 'Location',
        pointType: '',
        pointInfo: {},
        pointId: '',
        latitude: type === 'origin' ? data.pickupLat : data.deliveryLat,
        longitude: type === 'origin' ? data.pickupLon : data.deliveryLon,
        facilityId: null, 
        poiId: null, 
        tid: null,
        sid: null, 
        requestCompleted: false, 
        disabled: false, 
        note: '',
        appointmentTime: '',
        appointmentTimeZone: 'EST',
        uniqueIdentifier: null,
    }
}

const tripPlanPointInfo = (data) => {
    const stopList = data?.dispatchStopPointList && data?.dispatchStopPointList.length > 0 ? data?.dispatchStopPointList.map(item => {
        return {
            value: item.city,
            timeZone: item.timezone,
            dwellTime: '', 
            departureTime: '', 
            stopPointType: 'waypoint', 
            stopType: 'Location', 
            pointType: '', 
            pointInfo: {},
            pointId: '',
            latitude: item.lat,
            longitude: item.lon,
            facilityId: null,
            poiId: null,
            tid: null,
            sid: null,
            requestCompleted: false, 
            disabled: false, 
            note: '',
            appointmentTime: '',
            appointmentTimeZone: 'EST',
            uniqueIdentifier: null,
        }
    }) : []
    return [
        tripPlanParams(data, 'origin'),
        ...stopList,
        tripPlanParams(data, 'target')
    ]
}

function truckWebFormatToApiSend(info) {
    let options = info.checkedDangerousGoods.map(item => {
      return dangerousGoods.find(i => i.value === item).apiParam
    })
    return {
      id: info.id || null,
      trailers: info.trailers,
      axles: info.axles,
      truckAxleCount: info.axles,
      truckFtHeight: info.heightFt,
      truckFtLength: info.lengthFt,
      truckFtWidth: info.widthFt,
      truckInHeight: info.heightIn,
      truckInLength: info.lengthIn,
      truckInWidth: info.widthIn,
      truckName: info.truckName,
      weightLimit: (info.grossWeight || '').toString().replace(/[^\d]/g, ''),
      options: options.join(',')
    }
  }
  
  